import styled from '@emotion/styled';

export const Gallery = styled.ul`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 20px;
`;

export const GallleryItem = styled.li`
  position: relative;
  list-style: none;
`;
